import { Outlet } from "react-router-dom"
import { QueryClientProvider } from "@tanstack/react-query"

import { Nav } from "@/components/Nav"
import { Footer } from "@/components/Footer"
import { queryClient } from "@/lib/queryClient"

/**
 * Top-level layout shared by every route. Sticky header + content + footer.
 * The Nav and Footer are SSG-safe (no `document.write`, no jQuery hooks).
 *
 * QueryClientProvider lives here (not in main.tsx) because vite-react-ssg's
 * entry callback doesn't accept JSX wrappers. Putting providers in the route
 * layout is the canonical pattern with this plugin and matches React's
 * mental model anyway: providers live in the React tree.
 */
export function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex min-h-screen flex-col bg-slate-950 text-white">
        <Nav />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </QueryClientProvider>
  )
}
